var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800781 10.0508C0.800781 4.52793 5.27793 0.0507812 10.8008 0.0507812H38.8008C44.3236 0.0507812 48.8008 4.52793 48.8008 10.0508V38.0508C48.8008 43.5736 44.3236 48.0508 38.8008 48.0508H10.8008C5.27793 48.0508 0.800781 43.5736 0.800781 38.0508V10.0508Z",
    fill: "#155DFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 33.0508V31.0508C28.8008 29.9899 28.3794 28.9725 27.6292 28.2224C26.8791 27.4722 25.8616 27.0508 24.8008 27.0508H18.8008C17.7399 27.0508 16.7225 27.4722 15.9724 28.2224C15.2222 28.9725 14.8008 29.9899 14.8008 31.0508V33.0508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 15.1797C29.6585 15.4021 30.4182 15.903 30.9605 16.6037C31.5027 17.3045 31.797 18.1656 31.797 19.0517C31.797 19.9378 31.5027 20.7988 30.9605 21.4996C30.4182 22.2004 29.6585 22.7013 28.8008 22.9237",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8008 33.0516V31.0516C34.8001 30.1654 34.5051 29.3044 33.9621 28.604C33.4192 27.9035 32.6589 27.4032 31.8008 27.1816",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8008 23.0508C24.0099 23.0508 25.8008 21.2599 25.8008 19.0508C25.8008 16.8416 24.0099 15.0508 21.8008 15.0508C19.5916 15.0508 17.8008 16.8416 17.8008 19.0508C17.8008 21.2599 19.5916 23.0508 21.8008 23.0508Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/Organisation.bea2b0868b0f506cc907f765503466f5.svg";
export { ForwardRef as ReactComponent };